
<template>
    <date-picker v-model="valueLocal" :first-day-of-week="1" :lang="lang" format="DD.MM.YYYY" />
</template>

<script>
import DatePicker from 'vue2-datepicker'

import format from 'date-fns/format'

export default {
    components: {
        DatePicker
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        lang: {
            type: Object,
            default: _ => ({
                days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                placeholder: {
                    date: 'Выберите дату'
                }
            })
        }
    },

    data() {
        return {
            valueLocal: { ...this.value }
        }
    },

    watch: {
        value: function () {
            this.valueLocal = this.value
        },
        valueLocal: function () {
            if (this.valueLocal === this.value) {
                return
            }

            this.$emit('input', format(this.valueLocal, 'YYYY-MM-DD'))
        }
    }
}
</script>

<style scoped lang="scss">
    .input-group-append > .unitSelect {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
    }
</style>
